import styled from 'styled-components';
import { Button } from '~/ui/buttons';

/**
 * Editor secondary button. Resets EDS primary Button chrome (min-height,
 * Plus Jakarta, focus ring, color-mix hover) — editor UI is not a11y-scoped.
 */
const LightButton = styled(Button)`
  background-color: #f3ecff;
  color: #9738ff;
  font-weight: unset !important;
  font-family: ralewayBold;
  font-size: 14px;
  line-height: normal;
  min-height: 0;
  height: auto;
  padding: 8px 16px;
  gap: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:focus {
    outline: none;
  }

  &:focus::after {
    content: none;
    display: none;
  }

  &:hover:not(:disabled) {
    color: #fff;
    background-color: #9738ff;
    svg {
      path {
        fill: #fff !important;
      }
    }
  }

  &.active {
    background-color: #9845fb;
    color: #fff;
  }

  &:disabled {
    cursor: not-allowed;
    color: #6f6f6f;
    background-color: #f5f5f5 !important;
    svg {
      path {
        fill: #9a9a9a !important;
      }
    }
  }

  &:disabled:hover {
    background-color: #f5f5f5 !important;
    color: #6f6f6f !important;
    svg {
      path {
        fill: #9a9a9a !important;
      }
    }
  }
`;

export default LightButton;
